/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { colors } from "../colors";
import { StyledText } from "../../assets/typography/typography";

interface Props extends React.HTMLProps<HTMLDivElement> {
  title: string;
  children: React.ReactNode;
  titleVerticallyCentered?: boolean;
  customPadding?: string;
}

export const CardInformationRow = ({
  title,
  children,
  titleVerticallyCentered = false,
  customPadding,
  ...rest
}: Props) => {
  const wrapperStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    align-items: ${titleVerticallyCentered ? "center" : "flex-start"};
    gap: 8px;
    padding-top: ${customPadding || "16px"};
    padding-bottom: ${customPadding || "16px"};
    padding-left: ${customPadding || "24px"};
    padding-right: ${customPadding || "24px"};
    :not(:last-child) {
      border-bottom: 1px solid ${colors.greyBorder};
    }
  `;

  const elementWrapperStyle = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow-wrap: break-word;
  `;

  return (
    <div css={wrapperStyle} {...rest}>
      <div css={elementWrapperStyle}>
        <StyledText color={colors.textPrimary} className="bodyTextRegular mb-0">
          {title}
        </StyledText>
      </div>
      <div css={elementWrapperStyle}>{children}</div>
    </div>
  );
};
